export const submitForm = (form: HTMLFormElement | null) => {
  if (!form || typeof form !== 'object') {
    return;
  }

  if ('requestSubmit' in form && typeof form.requestSubmit === 'function') {
    form.requestSubmit();
    return;
  }

  const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
  form.dispatchEvent(submitEvent);
};
